export const getInitialState = () => ({
    fetchStatus: "initial",
    flight: undefined,
    error: undefined
});
